import React from 'react'

import {
  Button,
  Modal,
  ModalInjectedProps,
  TimeAgo,
  useModalContext,
} from '@sketch/components'

import {
  TokenDetailsRow,
  TokenDetailsModalBody,
  PermissionsHeading,
} from './ScimPersonalAccessTokenDetailsModal.styles'

import DeleteScimPersonalAccessTokenConfirmationModal from '../DeleteScimPersonalAccessTokenConfirmationModal'
import AccessScope, { allScopes } from '../../components/AccessScope'
import Divider from '../../components/Divider'
import TokenDetailsItem from '../../components/TokenDetailsItem'

import { dateFormat } from '@sketch/utils'

import { ScimPersonalAccessTokenFragment } from '@sketch/gql-types'

const localizeDate = (dateStr: string): string => dateFormat(new Date(dateStr))

interface ScimPersonalAccessTokenDetailsModalProps extends ModalInjectedProps {
  token: ScimPersonalAccessTokenFragment
}

const ScimPersonalAccessTokenDetailsModal: React.FCC<
  ScimPersonalAccessTokenDetailsModalProps
> = props => {
  const { token, hideModal } = props
  const { showModal } = useModalContext()
  const handleConfirmDeleteClick = () => {
    hideModal()
    showModal(DeleteScimPersonalAccessTokenConfirmationModal, { token })
  }

  const permissions = allScopes.map(scope => {
    const enabled = token.accessScopes.includes(scope)
    return <AccessScope key={scope} scope={scope} enabled={enabled} />
  })

  const expiresAt = token.expiresAt ? localizeDate(token.expiresAt) : 'Never'

  const lastUsedAt = token.lastUsedAt ? (
    <TimeAgo date={token.lastUsedAt} />
  ) : (
    'Unused'
  )

  return (
    <Modal title="SCIM Personal Access Token Details" onCancel={hideModal}>
      <TokenDetailsModalBody>
        <TokenDetailsRow>
          <TokenDetailsItem title="DESCRIPTION" value={token.description} />
          <TokenDetailsItem
            title="CREATED ON"
            value={localizeDate(token.createdAt)}
          />
        </TokenDetailsRow>
        <TokenDetailsRow>
          <TokenDetailsItem title="EXPIRES ON" value={expiresAt} />
          <TokenDetailsItem title="LAST USED" value={lastUsedAt} />
        </TokenDetailsRow>

        <Divider />

        <PermissionsHeading>PERMISSIONS</PermissionsHeading>

        {permissions}
      </TokenDetailsModalBody>
      <Modal.Footer>
        <Button onClick={handleConfirmDeleteClick} variant="negative-secondary">
          Delete…
        </Button>
        <Button onClick={hideModal}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ScimPersonalAccessTokenDetailsModal
